export default __webpack_public_path__ + "static/media/Screenshot_20210828-084319.09b06dc9.png";